module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 166
// module chunks = 0